import type { ReactNode } from 'react';

export const symbol_reset_shadow: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M538.5-138.5Q480-197 480-280t58.5-141.5Q597-480 680-480t141.5 58.5Q880-363 880-280t-58.5 141.5Q763-80 680-80t-141.5-58.5ZM680-140q-23-29-35.5-64.5T632-280q0-40 12.5-75.5T679-420q-57 0-98 41t-41 99q0 58 41 99t99 41ZM480-780q-125 0-212.5 87.5T180-480q0 81 38.5 147.5T320-226v-84q0-13 8.5-21.5T350-340q13 0 21.5 8.5T380-310v160q0 13-8.5 21.5T350-120H190q-13 0-21.5-8.5T160-150q0-13 8.5-21.5T190-180h91q-73-48-117-127t-44-173q0-75 28.5-140.5t77-114q48.5-48.5 114-77T480-840q123 0 216.5 72.5T824-583q4 12-2 22.5T804-546q-12 4-23-2t-15-18q-29-92-107-153t-179-61Z"
		/>
	</svg>
);
